import { createApi } from "@reduxjs/toolkit/dist/query/react";

import { httpService } from "@services/http.service";

import { IGetCourseApiParams, IGetCourseApiResponse } from "./lesson.types";

export const courseApi = createApi({
  reducerPath: "courseApi",
  baseQuery: httpService({
    baseUrl: `/api/v1`,
  }),
  tagTypes: ["courseData"],
  endpoints: (build) => ({
    getCourse: build.query<IGetCourseApiResponse, IGetCourseApiParams>({
      query: ({ courseId }) => ({
        url: `/user/info/courses/${courseId}/details/`,
        method: "get",
      }),
      providesTags: () => ["courseData"],
    }),
  }),
});

export const { useGetCourseQuery, useLazyGetCourseQuery } = courseApi;
